<template>
  <mp-table-body>
    <mp-table-row v-for="n in rows" :key="n">
      <mp-table-cell v-for="m in columns" :key="m" as="td" scope="row">
        <mp-skeleton variant-color="gray" width="inherit" height="20px" rounded="full" />
      </mp-table-cell>
    </mp-table-row>
  </mp-table-body>
</template>

<script>
export default {
  name: 'TableSkeleton',
  props: {
    rows: {
      type: Number,
      default: 5,
    },
    columns: {
      type: Number,
      default: 4,
    },
  },
};
</script>
